import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { SdsForm, SmartFormInterFace, SmartSoftButton, SmartSoftForm } from "soft_digi";
import { PAYMENT_URLS } from "../../api/UserUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { bills_all_select, hubs_get_all_select, vendors_get_all_select } from "../../services/site/SelectBoxServices";
import { post } from "../../services/smartApiService";
import PaymentInvoice from "./PaymentInvoice";
import PaymentsCount from "./PaymentsCount";
import RecentPayment from "./RecentPayment";
// import vendorWisePayment from "./vendorWisePayment";
import { motion } from 'framer-motion';
import BillWiseReport from "./BillWiseReport";
import VendorWisePayment from "./vendorWisePayment";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
const schema = Yup.object({})
const Payment = () => {
  const {
    control,
    handleSubmit,
    watch,reset,
    formState: { errors },
  } = useForm({
 
    resolver: yupResolver(schema),
  });
  const { setLoading, closeModal } = useSiteContext();
  const [customers, setCustomers] = useState([]);
  const [allHubs, setAllHubs] = useState([]);
  const [allBills, setAllBills] = useState([]);
  const [isFormVisible, setIsFormVisible] = useState(false);

  const [tabData, setTabData] = useState<any>();
  const loadTableData = (data: any) => {
    let URL = PAYMENT_URLS.GET_ALL_REPORT;
    const subscription = post(URL, { ...data }).subscribe((response) => {
      setTabData(response.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

useEffect(() => {
  loadTableData({});
}, []);

 const handleFilterClick = () => {
  if (isFormVisible) {
    reset({
      sd_bill_id: '',
      sd_customer_id: '',
      sd_hub_id: ''
    });
  }
  setIsFormVisible((prev) => !prev);
};



  useEffect(() => {
    vendors_get_all_select((data: any) => setCustomers(data));
    hubs_get_all_select((data: any) => setAllHubs(data));
    bills_all_select((data: any) => setAllBills(data));
  }, []);

  const options = [
    { value: "1", label: "Test" },
    { value: "2", label: "Test" },
    { value: "3", label: "test" },
  ];
    const formElements: SdsFormElementProps[] = [
    {
      type: "SELECT_BOX",
      width: 3,
      name: "sd_bill_id",
      element: {
        label: "Bill",
        isRequired: true,
        options: allBills,
        inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "SELECT_BOX",
      width:3,
      name: "sd_customer_id",
      element: {
        label: "Customer",
        isRequired: true,
        options: customers,
        inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "SELECT_BOX",
      width: 3,
      name: "sd_hub_id",
      element: {
        label: "Hub",
        isRequired: true,
        options: allHubs,
        inputProps: { isFocussed: true },
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "BUTTON",
      width: 3,
      name: "",
      // class_name: "has-text-right",
      element: {
        classList: ["smart-action-button"],
        label: "Apply Filter",
      },
    },]
    const tabs:any[] = [
      { title: 'Recent Payment', value: '1' },
      { title: 'Vendor Wise', value: '2' },
      { title: 'Bill Wise', value: '3' },
  
    ];
    const [activeIndex, setActiveIndex] = useState<any>("1");
    const TabsComponent = () => {
    
      return (
        <div className="tabs-container m-2">
          <div className="tabs is-toggle is-fullwidth custom-tabs">
            <ul>
              {tabs.map((tab) => (
                <motion.li
                  key={tab.value}
                  className={activeIndex === tab.value ? 'is-active' : ''}
                  onClick={() => setActiveIndex(tab.value)}
                  layout // Enables smooth movement
                  transition={{ type: "spring", stiffness: 300, damping: 20 }}
                >
                  <a>
                    <span>{tab.title}</span>
                  </a>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      );
    };
    
  
  return (
    <>
      <div className="is-size-3 has-text-font-bold ">

        <div className=" is-flex is-justify-content-space-between mb-2">
          <span className="is-size-4 has-text-weight-bold mb-1 has-text-white">Payment</span>

          <div className="has-text-right ">
            <SmartSoftButton
              label="Filter"
              leftIcon={isFormVisible ? "fa fa-times" : "fa fa-filter"}
              classList={["button", "mt-1",]}
              onClick={handleFilterClick}
            /></div>
        </div>   </div>
      {isFormVisible && (
        <div className="sd-efl-input mt-4">
            <SdsForm elements={formElements} errors={errors} control={control} />
        </div>
      )}

      <div className="has-text-white">

        <div className="">
          <PaymentsCount data={tabData?._payment_data} />
        </div>
   
        {/* <div className="m-4 mt-6">

          <PaymentInvoice data={tabData?._invoice_data||[]} />
        </div> */}
        <TabsComponent /> 
        {activeIndex==="1" &&
        <div className="m-4 ">
          <RecentPayment />
        </div>}
        {activeIndex==="2" &&
        <div className="m-4 ">
      <VendorWisePayment />
   
        </div>}
        {activeIndex==="3" &&
        <div className="m-4 ">
          <BillWiseReport />
        </div>}
      </div>
    </>
  );
};

export default Payment;
